'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icons = require('components/Common/Icons');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./EdgeView.pcss');

/* eslint max-len: 0 */

var BORDER_WIDTH = 40;

var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
  if (typeof value === 'function') return true;
};

var EdgeView = function (_Component) {
  _inherits(EdgeView, _Component);

  function EdgeView() {
    _classCallCheck(this, EdgeView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(EdgeView).apply(this, arguments));
  }

  _createClass(EdgeView, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer); // checks only for shallow equality of props
    }
  }, {
    key: 'getMovedCoords',
    value: function getMovedCoords() {
      var _props = this.props;
      var startX = _props.startX;
      var startY = _props.startY;
      var startDirX = _props.startDirX;
      var startDirY = _props.startDirY;
      var endX = _props.endX;
      var endY = _props.endY;
      var endDirX = _props.endDirX;
      var endDirY = _props.endDirY;

      var _getViewportCoords = this.getViewportCoords();

      var left = _getViewportCoords.left;
      var top = _getViewportCoords.top;


      var movedStartX = startX - left;
      var movedStartY = startY - top;
      var movedEndX = endX - left;
      var movedEndY = endY - top;

      var movedStartDirX = startDirX - left;
      var movedStartDirY = startDirY - top;
      var movedEndDirX = endDirX - left;
      var movedEndDirY = endDirY - top;

      return {
        movedStartX: movedStartX, movedStartY: movedStartY,
        movedEndX: movedEndX, movedEndY: movedEndY,
        movedStartDirX: movedStartDirX, movedStartDirY: movedStartDirY,
        movedEndDirX: movedEndDirX, movedEndDirY: movedEndDirY
      };
    }
  }, {
    key: 'getViewportCoords',
    value: function getViewportCoords() {
      var _Math, _Math2, _Math3, _Math4;

      var _props2 = this.props;
      var startX = _props2.startX;
      var startY = _props2.startY;
      var startDirX = _props2.startDirX;
      var startDirY = _props2.startDirY;
      var endX = _props2.endX;
      var endY = _props2.endY;
      var endDirX = _props2.endDirX;
      var endDirY = _props2.endDirY;


      var XPoints = [startX, startDirX, endDirX, endX];
      var YPoints = [startY, startDirY, endDirY, endY];

      var left = Math.round((_Math = Math).min.apply(_Math, XPoints) - BORDER_WIDTH) + 0.5;
      var right = Math.round((_Math2 = Math).max.apply(_Math2, XPoints) + BORDER_WIDTH) + 0.5;

      var top = Math.round((_Math3 = Math).min.apply(_Math3, YPoints) - BORDER_WIDTH) + 0.5;
      var bottom = Math.round((_Math4 = Math).max.apply(_Math4, YPoints) + BORDER_WIDTH) + 0.5;

      var width = right - left;
      var height = bottom - top;

      var centerX = width / 2 + left;
      var centerY = height / 2 + top;

      return {
        width: width, height: height,
        top: top, bottom: bottom, left: left, right: right,
        centerX: centerX, centerY: centerY
      };
    }
  }, {
    key: 'handleRemoveClick',
    value: function handleRemoveClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.props.onRemove();
    }
  }, {
    key: 'getHoverArea',
    value: function getHoverArea() {
      var disableModifications = this.props.disableModifications;

      if (disableModifications) return null;

      var _getMovedCoords = this.getMovedCoords();

      var movedStartX = _getMovedCoords.movedStartX;
      var movedStartY = _getMovedCoords.movedStartY;
      var movedEndX = _getMovedCoords.movedEndX;
      var movedEndY = _getMovedCoords.movedEndY;
      var movedStartDirX = _getMovedCoords.movedStartDirX;
      var movedStartDirY = _getMovedCoords.movedStartDirY;
      var movedEndDirX = _getMovedCoords.movedEndDirX;
      var movedEndDirY = _getMovedCoords.movedEndDirY;


      return _react2.default.createElement('path', {
        className: styles.pathHoverArea,
        d: 'M ' + movedStartX + ' ' + movedStartY + ' C ' + movedStartDirX + ' ' + movedStartDirY + ' ' + movedEndDirX + ' ' + movedEndDirY + ' ' + movedEndX + ' ' + movedEndY,
        strokeWidth: BORDER_WIDTH,
        stroke: 'none',
        fill: 'none'
      });
    }
  }, {
    key: 'getPathAttributes',
    value: function getPathAttributes() {
      var _props3 = this.props;
      var color = _props3.color;
      var dashed = _props3.dashed;


      var style = {
        strokeWidth: '1.0',
        stroke: color,
        fill: 'none',
        strokeDasharray: '16, 0'
      };

      if (dashed) {
        style = _extends({}, style, { strokeDasharray: '10, 6' });
      }

      return style;
    }
  }, {
    key: 'getPathStyle',
    value: function getPathStyle() {
      var dashed = this.props.dashed;


      if (!dashed) {
        return { strokeDashoffset: '10' };
      }
      return { strokeDashoffset: '6' };
    }
  }, {
    key: 'getEdgePath',
    value: function getEdgePath() {
      var _getMovedCoords2 = this.getMovedCoords();

      var movedStartX = _getMovedCoords2.movedStartX;
      var movedStartY = _getMovedCoords2.movedStartY;
      var movedEndX = _getMovedCoords2.movedEndX;
      var movedEndY = _getMovedCoords2.movedEndY;
      var movedStartDirX = _getMovedCoords2.movedStartDirX;
      var movedStartDirY = _getMovedCoords2.movedStartDirY;
      var movedEndDirX = _getMovedCoords2.movedEndDirX;
      var movedEndDirY = _getMovedCoords2.movedEndDirY;


      return _react2.default.createElement('path', _extends({
        className: styles.path,
        d: 'M ' + movedStartX + ' ' + movedStartY + ' C ' + movedStartDirX + ' ' + movedStartDirY + ' ' + movedEndDirX + ' ' + movedEndDirY + ' ' + movedEndX + ' ' + movedEndY
      }, this.getPathAttributes(), {
        style: this.getPathStyle()
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var highlight = _props4.highlight;
      var disableModifications = _props4.disableModifications;

      var _getViewportCoords2 = this.getViewportCoords();

      var width = _getViewportCoords2.width;
      var height = _getViewportCoords2.height;
      var left = _getViewportCoords2.left;
      var top = _getViewportCoords2.top;
      var centerX = _getViewportCoords2.centerX;
      var centerY = _getViewportCoords2.centerY;


      var classname = (0, _classnames2.default)(styles.edgeView, highlight && styles.highlighted);

      var showControls = !disableModifications;

      var result = _react2.default.createElement(
        'div',
        {
          className: classname
        },
        _react2.default.createElement(
          'svg',
          {
            className: styles.svgContainer,
            width: width,
            height: height,
            style: {
              position: 'absolute',
              left: left + 'px',
              top: top + 'px'
            }
          },
          this.getEdgePath(),
          this.getHoverArea()
        ),
        showControls && _react2.default.createElement(
          'div',
          {
            onClick: this.handleRemoveClick.bind(this),
            className: styles.removeContainer,
            style: { left: centerX + 'px', top: centerY + 'px' }
          },
          _react2.default.createElement(
            'div',
            { className: styles.remove },
            _react2.default.createElement(_Icons.Scissors, { className: styles.icon })
          )
        )
      );

      return result;
    }
  }]);

  return EdgeView;
}(_react.Component);

exports.default = EdgeView;


EdgeView.propTypes = {
  startX: _react.PropTypes.number.isRequired,
  startY: _react.PropTypes.number.isRequired,
  endX: _react.PropTypes.number.isRequired,
  endY: _react.PropTypes.number.isRequired,

  color: _react.PropTypes.string.isRequired,
  dashed: _react.PropTypes.bool,

  startDirX: _react.PropTypes.number.isRequired,
  startDirY: _react.PropTypes.number.isRequired,
  endDirX: _react.PropTypes.number.isRequired,
  endDirY: _react.PropTypes.number.isRequired,
  id: _react.PropTypes.any.isRequired,

  onRemove: _react.PropTypes.func.isRequired,

  disableModifications: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/EdgeView/EdgeView.js
// module id = 593
// module chunks = 1